<div class="fixed-section">
<app-project-info-header></app-project-info-header>
</div>

<div class="middleContent mt-131">
    <section class="mt-131">
        <div class="container-fluid px-2">
            <div class="row">
                <div class="col-md-12">
                    <div class="card border-0 stepsBars-2 mb-5">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-1 align-self-center">
                                    <h6 class="loginHeadingText text-start mb-0">SEARCH BY</h6>
                                </div>
                                <div class="col-md-4">
                                    <div class="d-flex w-100">
                                        <div class="align-self-center me-3 w-25 text-end">
                                            <label for="">PROJECT TITLE</label>
                                        </div>
                                        <div class="w-75 position-relative pe-4">
                                            <input type="text" class="form-control" placeholder="Project Title" (keyup)="onProjectTitleChange($event)" [(ngModel)]="txtSearchProjectTitle">
                                            <img src="assets/images/magnifying-glass.png" class="glassIcon" alt="">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2 pe-0">
                                    <div class="d-flex">
                                        <div class="align-self-center me-3 w-25 text-end">
                                            <label for="">CATEGORY</label>
                                        </div>
                                        <div class="w-75">
                                            <p-multiSelect [options]="categoryList" [(ngModel)]="selectedCategories" name="category" [showHeader]="true" [filter]="true"
                                                placeholder="Select Category" optionLabel="categoryName" (click)="stopPropagation($event)"
                                                (ngModelChange)="onSelectedCategory($event)">
                                                <ng-template let-category pTemplate="item">
                                                    <div class="hover-item" title="{{category.categoryName}}">
                                                        {{ category.categoryName }}
                                                    </div>
                                                </ng-template>
                                            </p-multiSelect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="d-flex">
                                        <div class="align-self-center me-3 w-50 text-end">
                                            <label for="">STARTED BEWTEEN</label>
                                        </div>
                                        <div class="w-75">
                                            <p-calendar name="dateCalendar" dateFormat="dd-M-yy" [(ngModel)]="selectedDateRange" (click)="stopPropagation($event)" (ngModelChange)="selectedSubmittedDateRange()"
                                                selectionMode="range">
                                            </p-calendar>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="d-flex">
                                        <div class="align-self-center me-3 w-25 text-end">
                                            <label for="">STATUS</label>
                                        </div>
                                        <div class="w-75">
                                            <select class="form-select" aria-label="Default select example" (change)="onSelectedStatus($event)">
                                                <option selected="" value="-1">Select Status</option>
                                                <option *ngFor="let status of statusList;" [value]="status">
                                                    {{status}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <div class="col-md-12">
                                    <table class="table datatable border-x-0 mb-0" *ngIf="verificationData && verificationData.length > 0">
                                        <thead>
                                            <tr class="subheaderrr">
                                                <th width="18%" rowspan="2">
                                                    PROJECT TITLE
                                                </th>
                                                <th width="8%" rowspan="2">
                                                    CATEGORY
                                                </th>
                                                <th width="6%" rowspan="2">
                                                    START DATE
                                                </th>
                                                <th width="6%" rowspan="2">
                                                    END DATE
                                                </th>
                                                <th width="12%" rowspan="2">
                                                    SPOC
                                                </th>
                                                <th width="4%" rowspan="2">
                                                    PWR #
                                                </th>
                                                <th width="8%" rowspan="2">
                                                    AGENCY
                                                </th>
                                                <th colspan="3">
                                                    PROJECT REPORT
                                                </th>
                                                <th width="6%" rowspan="2" class="border-end-0">
                                                </th>
                                            </tr>
                                            <tr class="subheaderrr">
                                                <th class="subtdBg">DATE</th>
                                                <th class="subtdBg">REPORT STATUS</th>
                                                <th class="subtdBg">REPORT</th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            <ng-container *ngFor="let proj of verificationData; let i = index">
                                                <tr>
                                                    <td class="text-start vertical-align-middle" [attr.rowspan]="proj.projectFilesCount">
                                                        {{proj.projectTitle}}
                                                    </td>
                                                    <td class="text-center vertical-align-middle" [attr.rowspan]="proj.projectFilesCount">
                                                        {{proj.categoryName}}
                                                    </td>
                                                    <td class="text-center vertical-align-middle" [attr.rowspan]="proj.projectFilesCount">
                                                        {{ proj.startDate | date:'dd-MMM-yyyy' }}
                                                    </td>
                                                    <td class="text-center vertical-align-middle" [attr.rowspan]="proj.projectFilesCount">
                                                        {{ proj.endDate | date:'dd-MMM-yyyy' }}
                                                    </td>
                                                    <td class="text-start vertical-align-middle" [attr.rowspan]="proj.projectFilesCount">
                                                        {{proj.spoc}}
                                                    </td>
                                                    <td class="text-center vertical-align-middle" width="5%" [attr.rowspan]="proj.projectFilesCount">
                                                        {{proj.pwR_Number}}
                                                    </td>
                                                    <td class="text-center vertical-align-middle" [attr.rowspan]="proj.projectFilesCount">
                                                        <strong>{{proj.agencyName}}</strong>
                                                    </td>
                                                    <td class="text-center">
                                                        {{ proj?.lstProjectFiles?.[0]?.createdDate | date:'dd-MMM-yyyy' }}
                                                    </td>
                                                    <td class="text-center vertical-align-middle">
                                                        <div>
                                                            <span [ngClass]="getStatusClassForProjectReport(proj?.lstProjectFiles?.[0]?.status)">{{proj?.lstProjectFiles?.[0]?.status}}</span>
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        <img src="assets/images/office365.png" alt="" class="excelIconn" title="Agency Report" *ngIf="proj?.projectFilesCount! > 0 && proj?.lstProjectFiles?.[0]?.projectID !== 0"
                                                            (click)="downloadProjectReportExcel($event, proj?.lstProjectFiles?.[0])"
                                                            style="cursor:pointer;">
                                                    </td>
                                                    <td class="text-center" [attr.rowspan]="proj?.projectFilesCount">
                                                        <button type="button" [attr.data-bs-toggle]="(proj?.projectFilesCount! > 0 && proj?.lstProjectFiles?.[0]?.projectID !== 0 ? 'modal' : null)"
                                                            [attr.data-bs-target]="(proj?.projectFilesCount! > 0 && proj?.lstProjectFiles?.[0]?.projectID !== 0 ? '#exampleModal' : null)"
                                                            class="btn btn-outline-dark me-2" [disabled]="(proj.status === 'Verified')"
                                                            [ngClass]="{'disableBtn': (proj.status === 'Verified')}" title="Upload Project Report"
                                                            (click)="selectProjectVerificationData(proj)">
                                                            <i class="fa-solid fa-upload"></i>
                                                        </button>
                                                        <app-file-upload #fileUpload [allowMultiple]="allowMultipleFiles" [agencyId]="proj.agencyID" [agencyName]="proj.agencyName ? proj.agencyName : ''"
                                                            [allowedFileTypes]="allowedFileTypeExtensions" (filesChanged)="onFilesChanged($event)"
                                                            style="display: none;"></app-file-upload>

                                                        <button type="button" class="btn btn-outline-success_2" title="Verify Project" (click)="NavigateToVerificationPage(proj.projectID, proj.projectTitle)"
                                                            [disabled]="!(proj?.isProcessedProject)" [ngClass]="{'disableBtn': !(proj?.isProcessedProject)}">
                                                            <i class="fa-solid fa-check"></i>
                                                        </button>
                                                        <!-- [disabled]="!(proj.Status === 'In Progress' || proj.Status === 'Verified')"
                                                        [ngClass]="{'disableBtn': !(proj.Status === 'In Progress' || proj.Status === 'Verified')}" -->
                                                    </td>
                                                </tr>
                                                <tr *ngFor="let projectFile of proj?.lstProjectFiles?.slice(1)">
                                                    <td class="text-center">{{projectFile.createdDate | date:'dd-MMM-yyyy'}}</td>
                                                    <td class="text-center" [ngClass]="getStatusClassForProjectReport(projectFile.status)">{{projectFile.status}}</td>
                                                    <td class="text-center" style="border-right: 1px solid #b4b4b4 !important;">
                                                        <img src="assets/images/office365.png" alt="" class="excelIconn" title="Agency Report" *ngIf="proj?.projectFilesCount! > 0"
                                                            (click)="downloadProjectReportExcel($event, projectFile)" style="cursor:pointer;">
                                                    </td>
                                                </tr>
                                            </ng-container>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="card" *ngIf="verificationData.length === 0 ">
                                <div class="card-body py-2 px-3">
                                    <div class="emtyCard p-0">
                                        <p class="mb-0">{{msgNoVerification}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<p-confirmDialog position="top" [baseZIndex]="200000" appendTo="body" role="alertdialog"></p-confirmDialog>

<div class="modal fade mt-131" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header py-2">Add Project Report
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div>
                        <h1 class="modal-title modalTitle" id="exampleModalLabel">There is/are existing Project Report(s). Please click the appropriate button for action</h1>
                        <h6 class="text-danger modalTitle">Please note, once the buttons are clicked, the below actions cannot be reverted.</h6>
                    </div>
                    <div class="col-md-5" style="padding-bottom:10px;">
                        <button class="btn progressBtn w-100 ps-2" role="button" data-bs-dismiss="modal" (click)="openFileDialog(1)">
                            <div class="d-flex">
                                <div>
                                    <img src="assets/images/green_plush.png" class="btnrefreshIcon" alt="">
                                </div>
                                <div>
                                    ADD NEW RECORDS
                                </div>
                            </div>
                        </button>
                    </div>
                    <div class="col-md-7" style="padding-bottom:10px;">
                        <p-multiSelect [options]="selectedProjectFilesData" [(ngModel)]="selectedProjectFiles" name="multiSelectProjectFiles" [showHeader]="true"
                            [filter]="true" placeholder="Select One/More Dates" optionLabel="createdDate" (click)="stopPropagation($event)"
                            [style]="{'width':'100%'}"> >
                            <ng-template let-file pTemplate="item">
                                <div class="hover-item" title="Actual FileName: {{file.fileName}}">
                                    {{ file.createdDate | date:'dd-MMM-yyyy' }}_{{file.filePath}}
                                </div>
                            </ng-template>
                        </p-multiSelect>
                    </div>
                    <div class="col-md-5" style="padding-bottom:10px;">
                        <button class="btn progressBtn w-100 ps-2" role="button" data-bs-dismiss="modal" (click)="openFileDialog(2)">
                            <div class="d-flex">
                                <div>
                                    <img src="assets/images/close_mark.svg" class="btnrefreshIcon" alt="">
                                </div>
                                <div>
                                    DELETE ALL RECORDS
                                </div>
                            </div>
                        </button>
                    </div>
                    <div class="col-md-7" style="padding-bottom:10px;">
                        <button class="btn progressBtn w-100 ps-2" role="button" [attr.data-bs-dismiss]="(selectedProjectFiles !== undefined ? 'modal' : null)"
                            (click)="openFileDialog(3)">
                            <div class="d-flex">
                                <div>
                                    <img src="assets/images/refreshIcon_blue.png" class="btnrefreshIcon" alt="">
                                </div>
                                <div>
                                    OVERWRITE FOR SELECTED DATES
                                </div>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>